import axios from 'axios';
import ensureArray from '@/utils/ensure-array';

export const setPromotionsForOrder = ({ commit }, payload) =>
	commit('setOrder', { promotions: ensureArray(payload) });

export const consumerOrderQueue = ({ commit }, payload) => {
	commit('consumerOrderQueueSubmission', payload);
};

export const consumerLead = async (ctx, payload) => {
	const { error } = await axios.post('/service/consumerlead', payload);

	if (error) {
		throw new Error(error);
	}
};


export const consumerLeadInitial = async ({ commit }, payload) => {
	try {
		const { consumer, vehicle } = payload;
		const { data: { id }, error } = await axios.post('/service/consumerlead/initial', {
			consumer,
			vehicle
		});

		if (error) {
			commit('setLeadID', String(''));
			console.error(error);
			throw new Error(error);
		}

		commit('setLeadID', String(id));
	} catch (err) {
		console.error('Error fetching consumer lead id: ', err);
		commit('setLeadID', '');

		throw new Error(err);
	}

	return false;
};


export const updateProductPaymentObject = ({ commit }, payload) => {
	return commit('updateProductPaymentObject', payload);

};

export const setConsumer = ({ commit }, data) => {
	const orderInfo = {
		consumer: {
			firstName: data.firstName,
			lastName: data.lastName,
			address: {
				line1: data.address.line1,
				line2: data.address.line2,
				city: data.address.city,
				state: data.address.state,
				zipCode: data.address.zipCode,
				country: 'US'
			},
			email: data.email,
			phone: data.phone,
			cellPhone: '',
			contactPreference: '',
			comments: data.comments,
			selectedFinancing: data.selectedFinancing
		},
		payer: {
			firstName: data.firstName,
			lastName: data.lastName,
			address: {
				line1: data.address.line1,
				line2: data.address.line2,
				city: data.address.city,
				state: data.address.state,
				zipCode: data.address.zipCode,
				country: 'US'
			}
		}
	};

	if (data.deliveryAddress) {
		orderInfo.consumer.deliveryAddress = {
			firstName: data.deliveryAddress.firstName,
			lastName: data.deliveryAddress.lastName,
			line1: data.deliveryAddress.line1,
			line2: data.deliveryAddress.line2,
			city: data.deliveryAddress.city,
			state: data.deliveryAddress.state,
			zipCode: data.deliveryAddress.zipCode,
			country: 'US'
		};
	}

	commit('setOrder', orderInfo);
};

